import { render, staticRenderFns } from "./PurchasesOrderViewGlobal.vue?vue&type=template&id=0a28ab1d"
import script from "./PurchasesOrderViewGlobal.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports